import { render, staticRenderFns } from "./createEditComissions.vue?vue&type=template&id=727c3a02&scoped=true&"
import script from "./createEditComissions.vue?vue&type=script&lang=js&"
export * from "./createEditComissions.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/modal.css?vue&type=style&index=0&id=727c3a02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727c3a02",
  null
  
)

export default component.exports